import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MAX_PAGE_HEIGHT } from '../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  signInWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: MAX_PAGE_HEIGHT,
  },
  signInContentWrapper: {
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
    width: '480px',
    padding: '16px',
  },
  signInForm: {
    width: '100%',
  },

  signInRole: {
    textTransform: 'capitalize',
  },

  textField: {
    '&:not(:first-of-type)': {
      marginTop: '16px',
    },
  },

  signInForgotPasswordButton: {
    width: '100%',
    textAlign: 'right',
    marginTop: '8px',
    marginBottom: '32px',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 400,
    fontSize: '12px',

    a: {
      color: theme.palette.primary.main,

      '&:hover': {
        color: theme.palette.primary.dark,
      },
    },
  },
  signInModeSwitcher: {
    textAlign: 'center',
    width: '100%',
    marginTop: '32px',
    fontWeight: 400,
    fontSize: '12px',
  },
  signInModeSwitcherButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  signInDivider: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
    marginBottom: '16px',
    color: theme.palette.grey[600],

    '& span': {
      marginLeft: '8px',
      marginRight: '8px',
      fontSize: '16px',
    },
    '& div': {
      flex: 1,
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
  },
}));
